










































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import billingAPI from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import { Account } from "../../models/account";
import { Currency } from "@/models/currency";
import { PackageGroup } from "../../models/packagegroup";
import clone from "@/helpers/clone";
import PackageHelpers, { Package } from "../../models/package";
import OrderHelpers, { Order } from "../../models/order";
import Currencies from "@/helpers/Currencies";
import ProductIcon from "@/components/ProductIcon.vue";
import { WarehousePackage } from "@/models/warehousePackage";
import { Warehouse } from "@/models/warehouse";
import { ServiceMatrix } from "@/models/serviceMatrix";
import { NSLog } from "@/helpers/log";
import { BundleWithQTY } from "@/models/bundle";
const log = NSLog("view/ManagePackages");

function findStringsMatchScore(src: string, searchWords: string[]): number {
  src = `${src}`.toLowerCase();
  // return searchWords.reduce((total, part) => total + src.indexOf(part) > -1 ? 1 : 0, 0);
  const score = searchWords.reduce((total, part) => total + (src.indexOf(part) > -1 ? 1 : 0), 0);
  return score >= searchWords.length ? 1 : 0;
}

@Component({
  components: {
    loader,
    ProductIcon,
  },
})
export default class SelectCustomer extends Vue {
  private allBundles: BundleWithQTY[] = [];
  private bundles: BundleWithQTY[] = [];
  public packages: Package[] = [];
  searchString = "";

  private get NeedShippingAddress() {
    return OrderHelpers.NeedShippingAddress(this.order);
  }
  private get valid() {
    return OrderHelpers.HasPackages(this.order);
  }

  get allCurrencies() {
    const cc = Currencies.map((c: any) => ({
      code: c.code,
      label: `${c.label} (${c.code})`,
    })).filter((c) => {
      // if (this.order && this.order.currency == "USD" && c.code == "ZAR")
      //   return false;
      return true;
    });
    return cc;
  }
  private get currency() {
    if (!this.order) {
      return "ZAR";
    }
    return this.order.currency || "ZAR";
  }
  @Mutation("setLastErr") public setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order!: Order;

  private loading = true;

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  get services() {
    return this.serviceMatrix.find(
      (mtix) => mtix.id === this.order!.service_matrix_id
    );
  }

  @Getter("warehouses") warehouses!: Warehouse[];
  get warehouse() {
    if (!this.order) return { id: 0 };
    return (
      this.warehouses.find((wh) => wh.id === this.services!.warehouse_id) || {
        id: 0,
      }
    );
  }
  @Getter("warehousepackages") warehousepackages!: WarehousePackage[];
  private isEnabled(warehouseID: number, ssCode: string) {
    return this.warehousepackages.find(
      (wp) => wp.warehouse_id == warehouseID && wp.short_code == ssCode
    )
      ? true
      : false;
  }

  // set helpers
  private setSelectedCurrency(cur: string) {
    if (!this.order) return;
    this.$emit(
      "update",
      { currency_estimated: this.order.currency == cur ? "" : cur },
      true
    );
    this.filterBundles();
  }

  private async next() {
    if (this.NeedShippingAddress) {
      this.$router.push("shipping_address");
    } else {
      this.$router.push("billing_address");
    }
  }

  filterBundles() {
    this.bundles = this.allBundles.filter((b) => {
      // console.log("bundle:", b);
      if (b.currency !== this.currency) return false;

      if (
        b.src_region !== undefined
        && b.src_region !== null
        && (b.src_region || '').toLowerCase() !== (this.services as any).src_region.toLowerCase()
      ) return false;

      if (
        b.dst_region !== undefined
        && b.dst_region !== null
        && (b.dst_region || '').toLowerCase() !== (this.services as any).dst_region.toLowerCase()
      ) return false;

      if (this.searchString) {
        const searchStrParts = `${this.searchString}`.trim().toLowerCase().split(' ');
        b._score = findStringsMatchScore(b.code, searchStrParts) + findStringsMatchScore(b.title, searchStrParts) + findStringsMatchScore(b.description, searchStrParts);
        return b._score > 0;
      } else {
        b._score = 0;
      }

      // ensure packages for bundle is available at warehouse
      const warehouseID = (this.services || {}).warehouse_id || -1;
      // console.log("b.package_short_codes: ", b);
      if (warehouseID == -1 || !b.package_short_codes || b.package_short_codes.length === 0) {
        return false;
      }
      return !b.package_short_codes.find((ssCode) => {
        // console.log("find ! enabled package", ssCode, this.isEnabled(warehouseID, ssCode));
        return !this.isEnabled(warehouseID, ssCode);
      })

      // return true;
    })
      .map((b) => ({ ...b, qty: 1, discount_rate: 0 }))
      .sort((a, b) => (b._score || 0) - (a._score || 0))
    // console.log("bundles:::", this.bundles);
  }

  private async mounted() {
    this.loading = true;
    try {
      const bundles: BundleWithQTY[] = clone(await billingAPI.listBundles());
      this.allBundles = bundles;
      this.filterBundles();
      this.packages = await billingAPI.listPackages();
    } catch (err) {
      log("err", err);
    }

    this.loading = false;
  }

  private discountLimit(v: any) {
    console.log("=== Got v:", v);
    let n = Math.trunc(Number(v));
    if (n < 0) {
      n = 0;
    }
    if (n > 100) {
      n = 100;
    }
    return n;
  }

  private async add(bdl: BundleWithQTY) {
    if (!bdl.qty) {
      return;
    }

    let discount = bdl.discount_rate || 0;
    if (discount > 100) {
      discount = 100;
    }
    if (discount < 0) {
      discount = 0;
    }

    // console.log('=== adding:', bdl);
    bdl.package_short_codes.forEach((pSCode) => {
      console.log()
      this.$emit(
        "updatePackageQty",
        pSCode,
        false,
        bdl.qty,
        false,
        discount,
        bdl.id
      );
    });
  }
}
